//  数据脱敏
export default function desensitization(type, str) {
    let reg = ''
    let times = ''
    switch (type) {
        case 'ali':
            reg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6}){0,1})$/
            if (reg.test(str)) {
                return str.replaceAll(/(^..)[^@]*(@.*$)/g, "$1*******$2")
            } else {
                return str.replaceAll(/^(\d{3})\d+(\d{4})$/g, "$1****$2")
            }
        case 'wx':
            var star = ''
            if (str.length >= 6 && str.length <= 8) {
                times = str.length - 4
                for (let i = 0; i < times; i++) {
                    star += '*'
                }
                return str.slice(0, 2) + star + str.slice(-2)
            } else {
                times = str.length - 7
                for (let i = 0; i < times; i++) {
                    star += '*'
                }
                return str.slice(0, 3) + star + str.slice(-4)
            }
        case 'bank':
            times = str.length - 8
            var star = ''
            for (let i = 0; i < times; i++) {
                star += '*'
            }
            return str.slice(0, 4) + star + str.slice(-4)
        case 'name':
          switch (str.length) {
            case 2:
            case 3:
                return '*' + str.slice(1)
            case 4:
            case 5:
            case 6:
                return '**' + str.slice(2)
            default:
                return str.slice(0, 2) + '**' + str.slice(str.length - 1)
        }
    }
}

// 移除网址开头的 http:// 或 https://
export function removeUrlProtocol(url) {
    return (url || '').replace(/^https?:\/\//, '')
}
